module.exports = __webpack_public_path__ + "img/busy_ringing.026b9d21.png";